type Meta = {
  total_count: number;
};

type DirectusResponse<T> = {
  data: T;
  meta?: Meta;
};

export default async function fetcher<T>(
  url: string,
  options: RequestInit = {},
): Promise<DirectusResponse<T>> {
  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(response.statusText);
    }
    const data = (await response.json()) as DirectusResponse<T>;

    return data;
  } catch (error) {
    console.log('error', error);
  }
  return { data: {} } as DirectusResponse<T>;
}
